import { render, staticRenderFns } from "./TheAdminList.vue?vue&type=template&id=d21cba18&scoped=true"
import script from "./TheAdminList.vue?vue&type=script&lang=ts"
export * from "./TheAdminList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21cba18",
  null
  
)

export default component.exports